import { Button, Divider, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { getAnalyticsLink } from "./analytics-links.config";
import { TopAffiliates } from "./top-affiliates.component";

const buttons = [
  { key: "dropOff", title: "Drop off", label: "View Data" },
  {
    key: "avgAppTime24h",
    title: "Avg. App Time per 24 hours",
    label: "View Data",
  },
  {
    key: "avgAppTimeSession",
    title: "Avg. App Time per session",
    label: "View Data",
  },
  {
    key: "revenueByCountry",
    title: "Revenue by country",
    label: "View Data",
  },
  {
    key: "revenueBySubscribers",
    title: "Revenue by subscribers",
    label: "View Data",
  },
  {
    key: "amountOfUsersPerSubscriptions",
    title: "Amount of users per subscriptions",
    label: "View Data",
  },
  {
    key: "revenueBySubscription",
    title: "Revenue by subscription",
    label: "View Data",
  },
  {
    key: "alfaCreatedDateNight",
    title: "Alfa created Date Nights",
    label: "View Data",
  },
  {
    key: "alfaCreatedEvents",
    title: "Alfa Created Events",
    label: "View Data",
  },
  {
    key: "userRoleDistribution",
    title: "User roles distribution",
    label: "View Data",
  },
  {
    key: "activeUsers",
    title: "Active users",
    label: "View Data",
  },
  {
    key: "age",
    title: "Age distribution",
    label: "View Data",
  },
  {
    key: "invitations",
    title: "Invitations (sent/accepted)",
    label: "View Data",
  },
];

export const Analytics: FC = () => {
  return (
    <Stack spacing={2}>
      <Grid
        container
        spacing={4}
        sx={{
          justifyContent: "start",
        }}
      >
        {buttons.map((btn, idx) => (
          <Grid
            key={idx}
            sx={{
              flex: "1 1 260px",
            }}
          >
            <Stack
              spacing={0.5}
              sx={{
                border: "1px solid rgba(70, 70, 70, 1)",
                borderRadius: 2,
                p: 1,
              }}
            >
              <Typography variant="button">{btn.title}</Typography>
              <Button
                component="a"
                href={getAnalyticsLink(btn.key)}
                size="small"
                color="secondary"
                variant="contained"
                target="_blank"
                rel="noopener noreferrer"
                disabled={!getAnalyticsLink(btn.key)}
              >
                {btn.label}
              </Button>
            </Stack>
          </Grid>
        ))}
      </Grid>

      <Divider />

      <TopAffiliates />
    </Stack>
  );
};
